import { useContext, useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import CampaignFormStepButtons from 'pages/campaigns/campaignForm/components/campaignFormContainer/components/campaignFormStepButtons/campaignFormStepButtons';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import PhotoGuidelineFieldGroup from './components/photoGuidelineFieldGroup/photoGuidelineFieldGroup';
import TextGuidelineFieldGroup from './components/TextGuidelineFieldGroup/TextGuidelineFieldGroup';
import VideoGuidelineFieldGroup from './components/videoGuidelineFieldGroup/videoGuidelineFieldGroup';
import { FashionCampaignFormStepTwoContext } from '../../fashionCampaignFormStepTwo.context';

const ReelsForm = () => {
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);
  const { needAdditionalPhotos, isFormValid, onClickNextButton } = useContext(
    FashionCampaignFormStepTwoContext,
  );

  const [photoModelFull, photoModelHalf, photoModelCloseup] = useWatch({
    control: guidelineRuleFormMethods?.control,
    name: [
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_FULL,
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_HALF,
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_CLOSEUP,
    ],
  });

  const isValidNextButton = useMemo(() => {
    if (
      !isFormValid ||
      // 추가 사진이 필요한데 추가 사진이 없을 경우
      (needAdditionalPhotos &&
        photoModelFull?.length <= 0 &&
        photoModelHalf?.length <= 0 &&
        photoModelCloseup?.length <= 0)
    ) {
      return false;
    } else {
      return true;
    }
  }, [
    isFormValid,
    needAdditionalPhotos,
    photoModelFull,
    photoModelHalf,
    photoModelCloseup,
  ]);

  return (
    <>
      {/* 영상 가이드라인 설정 */}
      <VideoGuidelineFieldGroup />

      {/* 문구 가이드라인 */}
      <TextGuidelineFieldGroup />

      {/* 릴스 외 사진 추가 사진 */}
      <PhotoGuidelineFieldGroup />

      <CampaignFormStepButtons
        disabledNextButton={!isValidNextButton}
        onClickNext={onClickNextButton}
      />
    </>
  );
};

export default ReelsForm;
